import React, {useRef, useState} from "react";
import emailjs from "emailjs-com";
import { Modal } from "react-bootstrap";
import { Button } from "react-bootstrap";

export const Email = () => {
    const successfull = "Your email has been successfully processed.";
    const failed = "Your email did not send out.";

    const [message, setMessage] = useState(successfull);
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);

    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs.sendForm('service_4aykd6h', 'template_pn1nedr', form.current, 'user_pOrQIg8l5qTwlJbudL36Z')
          .then((result) => {
              console.log(result.text);
              setMessage(successfull);
          }, (error) => {
              console.log(error.text);
              setMessage(failed);
          });
        e.target.reset();
        setShow(true);
      };

    return(
        <div>
            <div className="container">
                <form ref={form} onSubmit={sendEmail}>
                    <div className="row pt-6 mx-auto">
                        <div className="col-10 form-group mx-auto">
                            <input type="text" className="form-control" placeholder="Subject" name="subject"/>
                        </div>
                        <div className="col-10 form-group pt-2 mx-auto">
                            <input type="email" className="form-control" placeholder="Your email" name="email"/>
                        </div>
                        <div className="col-10 form-group pt-2 mx-auto">
                            <textarea className="form-control" id="" cols="30" rows="8" placeholder="Message" name="message"></textarea>
                        </div>
                        <div className="col-11 pt-3" style={{textAlign: "right"}}>
                            <input type="submit" className="btn btn-info btn-lg" value="Send" style={{color: "white"}}></input>
                        </div>
                    </div>
                </form>
            </div>
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Email Status</Modal.Title>
                </Modal.Header>
                <Modal.Body>{message}</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}